﻿/**
 * staff-favorite.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('staff-favorite.repository', staffFavoriteRepo);

	/** injection */
	staffFavoriteRepo.$inject = ['repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function staffFavoriteRepo(repositoryFactory, portalRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('StaffFavorite', portalRestangular);

		/** additional public methods */
		repo.getForUser = getForUser;
		repo.reorder = reorder;
		repo.deleteForUser = deleteForUser;

		/** get the favorites for a user */
		function getForUser() {
			/** send request */
			return portalRestangular.all(this.endpoint + '/getforuser').customGET().then(function(staffFavorites) {
				/** return staff favorites */
				return staffFavorites;
			});
		}

		/** define custom method */
		function reorder(favorites) {
			return this.put(favorites, '/reorder');
		}

		/** delete the favorite for the user by the portalLinkID */
		function deleteForUser(portalLinkID) {
			return portalRestangular.one(this.endpoint + '/deleteforuser', portalLinkID).remove();
		}

		/** return the repo */
		return repo;
	}
})();